import { useWindowWidth } from '@carta/ink';

export const useIsMobileLayout = () => {
  const { isMobile, isTabletPortrait } = useWindowWidth();
  return isMobile || isTabletPortrait;
};
